//@ts-nocheck
import React, { ReactElement } from 'react'
import { Query } from 'react-apollo'
import { get } from 'lodash'
import gql from 'graphql-tag'

const redeemShareQuery = gql`
    query redeemShareQuery($sharedStoryLinkId: ID!) {
        shareLinkCreator(sharedStoryLinkId: $sharedStoryLinkId) {
            id
            firstName
            lastName
            email
        }
    }
`

interface Props {
    sharedStoryLinkId: string,
    children: ({ shareLinkCreator: any }) => ReactElement
}

class RedeemShareQuery extends React.Component<Props> {
	parseData = data => ({
		shareLinkCreator: get(data, "shareLinkCreator", {})
	});

	render() {
        const { sharedStoryLinkId } = this.props

		return (
			<Query query={redeemShareQuery} variables={{ sharedStoryLinkId }}>
                {({ loading, error, data }) =>
					loading || error ? <div /> : this.props.children(this.parseData(data))
				}
			</Query>
		);
	}
}

export default RedeemShareQuery